export const ConnectionStatus = Object.freeze({
  ClientDisconnected: 'Disconnected',
  ClientConnected: 'Connected',
  ClientReconnection: 'ClientReconnection'
})

export const RunStates = Object.freeze({
  RunEdit: 'RunEdit',
  RunStarted: 'RunStarted',
  RunConference: 'RunConference',
  RunFinished: 'RunFinished',
  Unknown: 'Unknown'
})

const ExerciseEventType = Object.freeze({
  ExerciseAdded: 'ExerciseAdded',
  ExerciseRemoved: 'ExerciseRemoved'
})

/**
 * @typedef DocumentEventType
 */
/**
 * @enum {DocumentEventType}
 */
const DocumentEventType = Object.freeze({
  DocumentRemoved: 'DocumentsRemoved',
  DocumentAdded: 'DocumentsAdded',
  DocumentsCleared: 'DocumentsCleared'
})

/**
 * @property {ConnectionStatus} connectionStatus
 * @property {RunStates} runState
 */
const state = {
  connectionStatus: ConnectionStatus.Disconnected,
  runState: RunStates.Unknown,
  hubToken: '',
  exercises: {},
  exerciseDocuments: {}
}

export default state;
